import { Line, PolarArea, Bubble } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto"
import { SpeedOptions, SpinDirectionOptions, MovementOptions, ReleasePointConfig, ReleaseHeightTrendOptions, SpinTrendOptions, MovementTrendOptions, KZoneConfig, FieldConfig, KZoneConfig2 } from "./Options";
import { updateSpeedChartOptions, wrapSpeedChartData, wrapSpinDirectionData, wrapPointData, wrapTrendData } from "./utils";
import { PitcherPRChartTitleMap } from "../Map";
import { useRef, useState, useEffect } from "react";

export const SpeedChart = ({chartdata}) => {
  return (
    <>
      <Line data={wrapSpeedChartData(chartdata.global, chartdata.personal)} options={updateSpeedChartOptions(chartdata.personal, JSON.parse(JSON.stringify(SpeedOptions)))} />
    </>
  )
}

export const SpinDirectionChart = ({chartdata}) => {
  return (
    <PolarArea data={wrapSpinDirectionData(chartdata)} options={SpinDirectionOptions} />
  )
}

export const MovementChart = ({chartdata}) => {
  return (
    <Bubble data={wrapPointData(chartdata, 1)} options={MovementOptions} />
  )
}

export const ReleaseHeightPointChart = ({chartdata}) => {
  return (
    <Bubble data={wrapPointData(chartdata, 0)} options={ReleasePointConfig.options} plugins={ReleasePointConfig.plugins} />
  )
}

export const ReleaseHeightPointTrendChart = ({chartdata}) => {
  return (
    <Line data={wrapTrendData(chartdata, 'height', false)} options={ReleaseHeightTrendOptions} />
  )
}

export const SpinTrendChart = ({chartdata}) => {
  return (
    <Line data={wrapTrendData(chartdata, 'spin')} options={SpinTrendOptions} />
  )
}

export const MovementTrendChart = ({chartdata}) => {
  return (
    <Line data={wrapTrendData(chartdata, 'movement')} options={MovementTrendOptions} />
  )
}

export const KZoneChart = ({chartdata}) => {
  return (
    <Bubble data={wrapPointData(chartdata, 0.5)} options={KZoneConfig.options} plugins={KZoneConfig.plugins} />
  )
}

export const KZoneChart2 = ({chartdata}) => {
  return (
    <Bubble data={wrapPointData(chartdata, 0.5)} options={KZoneConfig2.options} plugins={KZoneConfig2.plugins} style={{height: '20vw', width: 'auto'}} />
  )
}


export const FieldChart = ({chartdata}) => {
  return (
    <Bubble data={wrapPointData(chartdata, 0)} options={FieldConfig.options} plugins={FieldConfig.plugins} />
  )
}

export const PRRangeElement = ({title, val}) => {
  const ref = useRef(null)
  const [step, setStep] = useState(0)
  useEffect(() => {
    const rangeLinePadding = 1.5 * window.innerWidth / 100;
    const calcStep =
      (ref.current.offsetWidth - rangeLinePadding) / ref.current.max;
    setStep(calcStep);
  }, []);
  return (
    <div className="pr_block">
      <div className="pr_topic">{title}</div>
      <div className="range-div">
        <input ref={ref} type="range" name="" className={"range range_color"+`${parseInt((val/10)+1)}`} min={0} max={100} step={1} value={val} disabled />
        <span className={"range-thumb"} style={{left: `${val * step}px`}}>{val}</span>
      </div>
    </div>
  )
} 
export const PRChart = ({chartdata}) => {
  const displayPR = (data) => {
    let output = []
    for (const i in data) {
      if (data[i] !== undefined) output.push(<PRRangeElement title={PitcherPRChartTitleMap[i]} val={data[i]} />)
    }
    return output
  }
  return (
    <>
      {displayPR(chartdata)}
    </>
  )
}